import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from "react-icons/fa";

const Contactussection1 = () => {
  const handleAppointment = (e) => {
    e.preventDefault();

    const name = e.target.name.value;
    const number = e.target.number.value;
    const email = e.target.email.value;
    const service = e.target.events.value;
    const notes = e.target.notes.value;

    const message = `Hello, I would like to book an appointment.\n\nName: ${name}\nPhone: ${number}\nEmail: ${email}\nService: ${service}\nMessage: ${notes}`;
    const whatsappNumber = "8123039669"; // Replace with your actual WhatsApp number (without '+')

    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <div className="contact-area section-padding bg-white my-14">
        <div className="xl:container mx-auto my-6 p-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="col-span-1">
              <div className="contact-text">
                <h2 className="text-3xl font-semibold text-black">
                  Are You Interested in Contacting Us?
                </h2>
                <p className="text-black mt-4">
                  Your Gateway to Hassle-Free Registrations
                </p>
                <div className="contact-sub mt-8">
                  <div className="flex items-center">
                    <FaMapMarkerAlt className="text-black text-2xl" />
                    <div className="contact-c ml-4">
                      <h4 className="text-lg font-semibold text-black">Our Location</h4>
                      <a
                        href="https://maps.google.com?q=WG26+9HG,Channasandra,Srinivaspura,Bengaluru,Karnataka560098"
                        className="text-black"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p className="font-bold">1) Head Office:</p>
                        202, Ground Floor, 17th E Main, 4th Cross Rd, KHB Colony, 5th Block, Koramangala, Bengaluru, Karnataka 560095
                        <p className="font-bold mt-2">2) Branch Office:</p>
                        208, Registration Guru  #537/B, Shubhaprada 11th block. B.S.K 6th Stage Srinivaspura, Uttarahalli Road, Bengaluru - 560060
                        <p className="font-bold">3) Branch Office:</p>
                        Sri Rama Residency, Shyanubhog Layout, Channasandra, Whitefield, Bengaluru, 560067.
                      </a>
                    </div>
                  </div>
                </div>
                <div className="contact-sub mt-4">
                  <div className="flex items-center">
                    <FaPhone className="text-black text-2xl" />
                    <div className="contact-c ml-4">
                      <h4 className="text-lg font-semibold text-black">Phone</h4>
                      <span className="text-black">
                        <a href="tel:+8904917771" className="text-black">7338017771</a><br />
                        <a href="tel:+7892929155" className="text-black">8904917771</a>
                        <a href="tel:+8904917771" className="text-black">7892929155</a><br />
                      </span>
                    </div>
                  </div>
                </div>
                <div className="contact-sub mt-4">
                  <div className="flex items-center">
                    <FaEnvelope className="text-black text-2xl" />
                    <div className="contact-c ml-4">
                      <h4 className="text-lg font-semibold text-black">Email</h4>
                      <span className="text-black">
                        <a href="mailto:info@registrationguru.org" className="text-black">
                          info@registrationguru.org
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form Section */}
            <div className="col-span-1">
              <div className="contact-content">
                <div className="contact-form">
                  <form onSubmit={handleAppointment}>
                    <div className="contact-form form-style grid grid-cols-2 md:grid-cols-2 gap-4">
                      <div className="col-span-1">
                        <input
                          type="text"
                          placeholder="Your Name*"
                          id="fname"
                          name="name"
                          className="border border-black py-2 px-4 rounded-md w-full"
                          required
                        />
                      </div>
                      <div className="col-span-1">
                        <input
                          type="text"
                          placeholder="Phone"
                          id="number"
                          name="number"
                          className="border-black border py-2 px-4 rounded-md w-full"
                          required
                        />
                      </div>
                      <div className="col-span-1">
                        <input
                          type="email"
                          placeholder="Your Email"
                          id="email"
                          name="email"
                          className="border-black border py-2 px-4 rounded-md w-full"
                          required
                        />
                      </div>
                      <div className="col-span-1">
                        <select
                          className="form-select border border-black py-2 px-4 rounded-md w-full"
                          name="events"
                          required
                        >
                          <option value="For Registration">For Registration</option>
                          <option value="For Divorce">For Divorce</option>
                          <option value="For Cyber Crime">For Cyber Crime</option>
                          <option value="Criminal Matter">Criminal Matter</option>
                          <option value="Maintenance">Maintenance</option>
                          <option value="Child Custody">Child Custody</option>
                          <option value="Bank Account De-freezing">Bank Account De-freezing</option>
                          <option value="Anticipatory Bail">Anticipatory Bail</option>
                          <option value="Regular Bail">Regular Bail</option>
                          <option value="Judicial Separation">Judicial Separation</option>
                          <option value="Restitution of Conjugal Right (RCR)">Restitution of Conjugal Right (RCR)</option>
                        </select>
                      </div>
                      <div className="col-span-2">
                        <textarea
                          className="contact-textarea border border-black py-2 px-4 rounded-md w-full"
                          placeholder="Message"
                          name="notes"
                        ></textarea>
                      </div>
                      <div className="col-span-2">
                        <button
                          type="submit"
                          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"
                        >
                          Appointment
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Google Maps */}
        <div style={{ width: "100%", textAlign: "center" }}>
          <iframe
            width="50%"
            height="500"
            frameBorder="0"
            title="Registration Guru"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            src="https://maps.google.com/maps?width=100%25&amp;height=500&amp;hl=en&amp;q=Registration%20Guru%20WG26+9HG,%20Channasandra,%20Srinivaspura,%20Bengaluru,%20Karnataka%20560098+(Registration%20Guru)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
            style={{ margin: "auto" }}
          >
            <a href="https://www.maps.ie/population/">Registration Guru</a>
          </iframe>
        </div>
      </div>
    </>
  );
};

export default Contactussection1;
